
import { Component, Vue } from "vue-property-decorator";
import Util from "@/lib/util";
import Pagination from "@/components/Pagination/index.vue";
import { CarouselService, CarouselDto } from "@/api/service-proxies";
import PagedListBase, {
  PagedRequestDto
} from "@/lib/view-base/paged-list-base";
import phoneDialog from "../components/preViewPhoneDialog.vue"
class CarousePagedRequest extends PagedRequestDto {
  Title!: string;
}

@Component({
  name: "Tenant",
  components: {
    Pagination, phoneDialog
  }
})
export default class Tenant extends PagedListBase<
  CarousePagedRequest,
  CarouselDto
> {
  request = new CarousePagedRequest();
  carouselService = new CarouselService();

  value = null


  value1 = ''
  value2 = ''
  created() {
    this.refresh();
  }

  getpage(finishCallback: Function): void {
    this.carouselService
      .getAll(
        this.request.Title,
        this.request.sorting,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then(result => {
        result.items.forEach((e)=>{
          e.p_Path = (this as any).$aes.imgAddAuth(e.p_Path);

        })
        this.list = result.items;
        this.showPaging(result);
      })
      .finally(() => {
        finishCallback();
      });
  }
  handleCreate() {
    this.$router.push({ path: "/carousel/create" });
  }
  handleUpdate(carousel: CarouselDto) {
    this.$router.push({ path: `/carousel/update/${carousel.id}` });
  }
  handleDelete(carousel: CarouselDto) {
    this.$confirm("确定删除产品?")
      .then(async () => {
        await this.carouselService.delete(carousel.id);
        this.$notify.success("删除成功");
        this.refresh();
      })
      .catch(() => { });
  }
  openPhoneDialog(row) {
    (this.$refs.phoneDialogRef as phoneDialog).open(row)
  }

}
